import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ButtonLoading } from "go-form";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import { LoadingContainer } from "go-core/components/Loading";
import { FormDirty } from "go-form/components/FormDirty";
import { adminApi } from "../../../../../../../../services/Api/Admin/adminApi";
import { ProductCatalogApi } from "../../../../../../../../services/Api/Admin/adminTypes";
import ProductCatalogPreview from "./components/ProductCatalogPreview";

const AdminToolsProductCatalogPage = () => {
	const [catalog, setCatalog] = useState<ProductCatalogApi | undefined>(undefined);
	const { addFlash, addSuccessFlash } = useFlash();
	const [loading, setLoading] = useState(false);
	const { t } = useTranslation("admin");
	const { handleChangeTabTitle } = useBrowserTabTitle();

	useEffect(() => {
		fetchProductCatalog();
	}, []);

	const fetchProductCatalog = async () => {
		try {
			const res = await adminApi.getProductCatalog();
			setCatalog(res);
			handleChangeTabTitle(
				`${t("modules.tool.field.subscriptions_price_list.title")} | ${t("lib:go_component.navigation.admin")}`
			);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	const onRebuild = async () => {
		setLoading(true);
		try {
			const res = await adminApi.rebuildProductCatalog();
			setCatalog(res);
			addSuccessFlash(t("modules.tool.field.calculated.title"));
		} catch (err) {
			handleError.alert(err, addFlash);
		}
		setLoading(false);
	};

	if (!catalog) {
		return <LoadingContainer />;
	}

	return (
		<FormDirty isDirty={false}>
			<ProductCatalogPreview catalog={catalog} />
			<div className={"form-footer"}>
				<ButtonLoading loading={loading} onClick={onRebuild}>
					{t("common.action.calculate")}
				</ButtonLoading>
			</div>
		</FormDirty>
	);
};
export default AdminToolsProductCatalogPage;
